/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import {
  ChevronDownIcon,
  constantSemanticColors,
  numericPercentages,
  radius,
  spacing,
  Text,
} from "@packages/ui";
import { forwardRef } from "react";

const disabledStyles: Interpolation = {
  cursor: "default",
  pointerEvents: "none",
};

const selectMenuTriggerContainerStyles: Interpolation = {
  alignItems: "center",
  background: constantSemanticColors.fixedLightenLower,
  border: "none",
  borderRadius: radius.m,
  color: constantSemanticColors.onColorHighest,
  cursor: "pointer",
  display: "flex",
  gap: spacing.s,
  justifyContent: "space-between",
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  paddingTop: spacing.s,
  paddingBottom: spacing.s,
  width: numericPercentages[100],
};

const textContainerStyles: Interpolation = {
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
};

const labelTextStyles: Interpolation = {
  color: constantSemanticColors.onColorVeryHigh,
  textTransform: "uppercase",
};

const textStyles: Interpolation = {
  textAlign: "left",
};

type PrayerOptionSelectTriggerProps = {
  label: string;
  value: string;
  disabled?: boolean;
};

export const PrayerOptionSelectTrigger = forwardRef<
  HTMLButtonElement,
  PrayerOptionSelectTriggerProps
>((props, ref) => (
  <button
    css={[selectMenuTriggerContainerStyles, props.disabled && disabledStyles]}
    ref={ref}
    {...props}
  >
    <div css={textContainerStyles}>
      <Text type="detail" size="m" css={labelTextStyles}>
        {props.label}
      </Text>
      <Text type="title" size="m" css={textStyles}>
        {props.value}
      </Text>
    </div>
    {!props.disabled && <ChevronDownIcon />}
  </button>
));

PrayerOptionSelectTrigger.displayName = "PrayerOptionSelectTrigger";
